import React from 'react';
import { motion } from 'framer-motion';
type Props = {
  eyebrow: string;
  title: string;
  intro?: string;
};
export function PageHeader({
  eyebrow,
  title,
  intro
}: Props) {
  return <header className="px-6 pb-16 pt-40 sm:px-10 sm:pt-48" data-id="element-125" data-mp="3rec7hmk18rhh">
      <div className="mx-auto max-w-[92rem]" data-id="element-126" data-mp="3rducet93wjb5">
        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        ease: [0.22, 1, 0.36, 1]
      }} className="eyebrow text-mocha" data-id="element-127" data-mp="3mezlt54wdqgh">
          {eyebrow}
        </motion.p>
        <motion.h1 initial={{
        opacity: 0,
        y: 22
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.9,
        delay: 0.08,
        ease: [0.22, 1, 0.36, 1]
      }} className="mt-6 max-w-4xl font-serif text-[3rem] font-light leading-[0.98] tracking-[-0.01em] text-charcoal sm:text-[4.5rem]" data-id="element-128" data-mp="2toqzr278qlwm">
          {title}
        </motion.h1>
        {intro && <motion.p initial={{
        opacity: 0,
        y: 22
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.9,
        delay: 0.16,
        ease: [0.22, 1, 0.36, 1]
      }} className="mt-8 max-w-xl text-base leading-relaxed text-charcoal/65" data-id="element-129" data-mp="2b03v2ksz7yjk">
            {intro}
          </motion.p>}
      </div>
    </header>;
}